import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Image from 'next/image';

import constants from '@/shared/constants/gift-cards-page';
import Button from '@/shared/molecules/Button';
import { YumBalanceChecker } from '@/shared/pages/gift-cards/YumBalanceChecker/YumBalanceChecker';

import css from './Page.module.css';

type GiftCardPageProps = {
  yumToken: string;
}

const GiftCardPage = ({ yumToken }: GiftCardPageProps): JSX.Element | null => (
  <Grid container>
    <Grid item>
      <Box marginBottom="2rem" marginTop="2rem">
        <Typography
          gutterBottom
          variant="h1"
          className={css.header}
          data-testid="gift-cards-page-header"
        >
          Gift Cards
        </Typography>
      </Box>
      <Image
        id="gift-cards-image"
        priority
        height={210}
        width={330}
        alt="Image of a gift card with text: Pizza Hut, No one outpizzas the hut"
        src={constants.IMAGE_GIFT_CARD_WITH_LOGO}
      />
      <Box marginBottom="4rem" marginTop="1rem">
        <Button
          id="faqs-button-gift-cards-page"
          testId="buy-gift-cards-button"
          type="button"
          buttonBaseTag="a"
          label="Buy Gift Cards"
          size="medium"
          color="secondary"
          variantStyle="contained"
          minWidth="330px"
          linkTarget="_blank"
          href={constants.PURCHASE_GIFT_CARDS_LINK}
        />
      </Box>
      <Box marginBottom="1rem" marginTop="1rem" maxWidth={500}>
        <Typography variant="h2">
          Check your balance
        </Typography>
        <Typography>
          Gift Card with expiration date & CVV? Please check your balance by going to <a href="https://merchantgiftcard.giftcardmall.com" target="_blank" rel="noreferrer">https://merchantgiftcard.giftcardmall.com</a> or call 866-294-6806
        </Typography>
      </Box>
      <YumBalanceChecker yumToken={yumToken} />
    </Grid>
  </Grid>
);

export default GiftCardPage;
